// Движок вычисления формул
import { Parser } from 'expr-eval';
import type { Row, ColumnConfig } from './types';

const parser = new Parser();

/**
 * Вычисляет значение формулы для строки данных
 * @param formula Формула (например: "kf_prikaz - kf_fact")
 * @param row Строка данных
 * @param columns Конфигурация колонок
 * @returns Вычисленное значение
 */
export function evaluateFormula(
  formula: string,
  row: Row,
  columns: ColumnConfig[]
): number | null {
  try {
    // Создаём контекст с полями строки
    const context: Record<string, any> = {};

    columns.forEach((col) => {
      const value = row[col.field];
      // Преобразуем в число для вычислений
      context[col.field] = typeof value === 'number' ? value : parseFloat(value) || 0;
    });

    // Парсим и вычисляем формулу
    const expr = parser.parse(formula);
    const result = expr.evaluate(context);

    return typeof result === 'number' ? result : null;
  } catch (error) {
    console.error('Ошибка вычисления формулы:', formula, error);
    return null;
  }
}

/**
 * Проверяет корректность формулы
 * @param formula Формула для проверки
 * @returns true если формула валидна
 */
export function validateFormula(formula: string): boolean {
  try {
    parser.parse(formula);
    return true;
  } catch {
    return false;
  }
}

/**
 * Извлекает список полей, используемых в формуле
 * @param formula Формула
 * @returns Список имён полей
 */
export function getFormulaDependencies(formula: string): string[] {
  try {
    const expr = parser.parse(formula);
    return expr.variables();
  } catch {
    return [];
  }
}
